import { render, staticRenderFns } from "./DeliveryList_List_Action.vue?vue&type=template&id=4b7cbec3&"
import script from "./DeliveryList_List_Action.vue?vue&type=script&lang=js&"
export * from "./DeliveryList_List_Action.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports